/* --------------------------------------------------------------------------------------
   onTap.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

 export class onTap {
  constructor() {
    this.restrict = 'A'
    this.scope = {
      onTap: '&'
    }
  }
  link(scope, elem, attrs) {
    elem.bind('mousedown', e => {      
      this.originalX = e.clientX
      this.originalY = e.clientY
    })
    elem.bind('mouseup', e => {
      if (Math.abs(this.originalX - e.clientX) < 5 && Math.abs(this.originalY - e.clientY) < 5) {
        document.activeElement.blur()
        scope.onTap()
      }      
    })
  }
  static directiveFactory() {
    onTap.instance = new onTap()
    return onTap.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/common/directives/onTap.directive.js